import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'if_no_desc_when_assessor_on_site_and_why_verif_not_take_place'

export const dataPointDefinition = {
  retracedId: 'if_no_desc_when_assessor_on_site_and_why_verif_not_take_place',
  name: 'If no, please describe which days Verifier(s)/Assessor(s) were on site and why the verification did not take place over ',
  description:
    '"On site" means physically on site at the facility or virtually on site conducting verification/assessment activity. ',
  meta: {
    slcpMeta: {
      key: 'vd-e9',
      number: 'VD-VERI-5.1',
      dataType: 'string',
      masterType: 'Follow-up',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: '',
      verificationSelectionOptList: '',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: 'vd-e8,No',
      machineShowHide: 'vd-e8,2',
      completionCondition: '',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'vd-e9', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34690,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
